export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteFooter.vue?vue&type=template&id=3e8ea87e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteFooter.vue?vue&type=template&id=3e8ea87e&scoped=true&
// module id = 53
// module chunks = 0